import React from "react";
import { SlideMap } from "./ckeditor/CkEditorHelper";
import { Editor } from "./ckeditor/Editor";
import { PreviewSlide } from "./PreviewSlide";
import { TextAnalysis } from "../../../utilities/sermonAnalyzer/SermonAnalyzer";

interface EditorState {
	lastEdit: string;
	saveInProgress: boolean;
	slides: PreviewSlide[];
	wordCount: number;
	characterCount: number;
	gradeLevel: string;
	improvements: TextAnalysis[];
	goodResults: TextAnalysis[];
	keywords: string[];
	scriptureReferences: string[];
	writingLogCreated: boolean;
	setEditor: (editor: Editor) => void;
	onRemoveSlide: (slide: SlideMap) => void;
	onRemovePreviewSlide: (previewSlide: PreviewSlide) => void;
	getHtml: () => string;
	getBubbleText: () => string;
	getBubbleWordCount: () => number;
	hideFormatBubble: () => void;
	onEditorDomChange: () => void;
	updateAnalyzerResults: () => void;
}

export const EditorContext = React.createContext<EditorState>({} as any);

export function useEditor() {
	return React.useContext(EditorContext);
}
